module.exports = __webpack_public_path__ + "media/landing-page/gls-bubble-95c2bef4.png";